import { Routes } from "@angular/router";

export const content: Routes = [
    {
    path: '',
    data: {
        title: "main Dashboard",
        breadcrumb: "main Dashboard",
    },
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    },
    {
      path: 'tickets',
      data: {
          title: "Tickets",
          breadcrumb: "Tickets",
      },
      loadChildren: () => import('./pages/ticket/ticket.module').then(m => m.TicketModule),
    },
    {
        path: 'messaging',
        data: {
            title: "chat",
            breadcrumb: "Tichatckets",
        },
        loadChildren: () => import('./pages/chat/chat.module').then(m => m.ChatModule),
      },
    {
        path: 'settings',
        data: {
            title: "settings",
            breadcrumb: "settings",
        },
        loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule),
    },
    {
        path: 'users',
        data: {
            title: "users",
            breadcrumb: "users",
        },
        loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule),
    },
    {
      path: 'automation',
      data: {
          title: "Macros",
          breadcrumb: "Macros",
      },
      loadChildren: () => import('./pages/automation/automation.module').then(m => m.AutomationModule),
    },
    {
      path: 'knowledgebase',
      data: {
          title: "Base De Conhecimento",
          breadcrumb: "Base De Conhecimento",
      },
      loadChildren: () => import('./pages/knowledgebase/knowledgebase.module').then(m => m.KnowledgeBaseModule),
    },
    {
      path: 'configuration',
      data: {
          title: "Configuração",
          breadcrumb: "Configuração",
      },
      loadChildren: () => import('./pages/configuration/configuration.module').then(m => m.ConfigurationModule),
    },
    {
        path: 'clients',
        data: {
            title: "clients",
            breadcrumb: "clients",
        },
        loadChildren: () => import('./pages/clients/clients.module').then(m => m.ClientsModule),
    },
    {
        path: 'chatgroup',
        data: {
            title: "chatgroup",
            breadcrumb: "chatgroup",
        },
        loadChildren: () => import('./pages/chat-group/chat-group.module').then(m => m.ChatGroupModule),
    },
    {
        path: 'teams',
        data: {
            title: "users team",
            breadcrumb: "users team",
        },
        loadChildren: () => import('./pages/user-team/users-team.module').then(m => m.UsersTeamModule),
    },
    {
        path: 'chatapp',
        data: {
            title: "chat app",
            breadcrumb: "users team",
        },
        loadChildren: () => import('./pages/chat-app/chat-app.module').then(m => m.ChatAppModule),
    },
    {
        path: 'whatsapp',
        data: {
            title: "WhatsApp",
            breadcrumb: "WhatsApp"
        },
        loadChildren: () => import('./pages/whatsapp/whatsapp.module').then(m => m.WhatsappPageModule)
    },
    {
        path: 'integration',
        data: {
            title: "Integração",
            breadcrumb: "users team",
        },
        loadChildren: () => import('./pages/integration/integration.module').then(m => m.IntegrationModule),
    },
    {
        path: 'trigger',
        data: {
            title: "Gatilhos",
            breadcrumb: "Event Triggers",
        },
        loadChildren: () => import('./pages/event-triggers/event-triggers.module').then(m => m.EventTriggersModule)
    }
    
]


